<template>
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <v-dialog persistent v-model="uploadDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="currentparking.name" :label="$t('lblName')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="currentparking.value" :label="$t('lblmMxValue')"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="currentparking.maxValue" :label="$t('lblmMxValue')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-text-field
        solo
        class="mt-4"
        label="buscar"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <v-data-table
        :headers="headers"
        :items="parking"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >

        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showUploadDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";

export default {
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
    this.loadData();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      newDialog: false,
      deleteDialog: false,
      uploadDialog: false,
      viewDialog: false,
      dialogHelp: false,
      selected: null,
      snackbar: false,
      mensaje: "",
      search: "",
      loading: true,
      dialog: false,
      parking: [],
      currentparking: { resource: {} },
      errorMessage: "",
      ubicRules: [
        v => v.length > 0 || "Debes ingresar una ubicacion",
        v => v.length < 100 || "No puedes ingresar mas de 100 caracteres"
      ],
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Cupo Total", value: "maxValue" },
        { text: "Cupo Disponible", value: "value" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      checkbox_options: [
        { value: 1, text: "TIENE/NO TIENE" },
        { value: 2, text: "CANTIDAD" },
        { value: 5, text: "DESCRIPCIÓN" }
      ]
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
    },
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    loadData() {
      let settings = {
        locationId: this.$route.params.idLocation
      };
      this.$GET("//api/locations/{{locationId}}/parking", settings)
        .then(data => {
          this.parking = [data];
          //** console.log(this.parking);
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    showUploadDialog(item) {
      this.currentparking = item;
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      this.uploadDialog = false;
      this.currentparking = { resource: {} };
      this.$refs.updateMapForm.reset();
      this.errorMessage = "";
    },
    doUploadDialog() {
      let payload = {
        params: {
          parkingValue: this.currentparking.id,
          locationId: this.$route.params.idLocation
        },
        data: {
          name: this.currentparking.name,
          value: this.currentparking.value,
          maxValue: this.currentparking.maxValue,
          lastUpdate: this.parking.lastUpdate
        }
      };
      /*
       console.log(
        "/api/locations/{{locationId}}/parking/{{parkingValue}}",
        payload
      );
      */

      this.$PUT(
        "/api/locations/{{locationId}}/parking/{{parkingValue}}",
        payload
      )
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.uploadDialog = false;
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al crear el mapa";
        })
        .finally(() => {});
    }
  }
};
</script>